<template lang="pug">
  SspLayout(area="core")
    .col-sm-12
      ActivateForValidation(v-model="activation")
</template>

<script>
import ActivateForValidation from '@/components/ssp/ActivateForValidation'

export default {
  components: {
    ActivateForValidation
  }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/ActivateOrder.vue